import { createContext } from 'react'

import {
  MeetingsMeetingProviderItemFragment,
  MeetingsMeetingProviderItemPageFragment,
} from 'generated/resources/graphql'

export interface MeetingsMeetingContextState {
  notes: string | null
  setNotes: (notes: string) => void
  loading: boolean
  isSavingNotes: boolean
  error: string | null
  page: MeetingsMeetingProviderItemPageFragment | null
  meeting: MeetingsMeetingProviderItemFragment | null
  canUseAI: boolean
  meetingId: number | null
  setMeetingId: (meetingId: number) => void
}

export const MeetingsMeetingContext = createContext<MeetingsMeetingContextState | undefined>(
  undefined
)
